/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationSubClassificationQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("RecommendationSubClassificationQueryOperator");
    }

    getFixupPrototypeFunction() { return RecommendationSubClassificationQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<RecommendationSubClassificationQueryOperator>): RecommendationSubClassificationQueryOperator {
        let obj = Object.assign(new RecommendationSubClassificationQueryOperator(), model);
        RecommendationSubClassificationQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationSubClassificationQueryOperator>): RecommendationSubClassificationQueryOperator {
        if (!model) return null;
        return RecommendationSubClassificationQueryOperator.newInstance(<RecommendationSubClassificationQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationSubClassificationQueryOperator) {
        if (!obj) return;

        models.RecommendationSubClassificationQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationSubClassificationQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationSubClassificationQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Id of the workflow
     */
    recommendation_sub_classifications: Array<models.RecommendationV2SubClassifications>;

}
